
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IndexManager } from '../manager'
import { IndexService } from '../service'

@Component({
  components: {
  }
})

export default class extends Vue {
  private manager: IndexManager = new IndexManager(new IndexService())

  mounted () {
    this.manager.getSelectedCourseManager()
  }

  CourseDetails (item: any) {
    // console.log(item)
    const url = process.env.VUE_APP_SMALL_URL
    window.location.href = (url + `/channel.html#/selectedCourse/?item=${(JSON.stringify(item))}`)
  }
}
